import React from "react";
import { TableRow, TableCell, Box, Typography, Avatar } from "@mui/material";
import SessionsActivityBar from "./SessionsActivityBar";

const projectColors = {
  SG: "#6A0DAD",
  PQ: "#1976d2",
  CB: "#d81b60"
};

const SessionsMemberDetailsRow = ({ detail, index, rowDetails }) => {
  let counter = 0;
  for (let j = 0; j <= index; j++) {
    if (rowDetails[j].date) counter++;
  }

  return (
    <TableRow>
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
        {detail.date ? counter : ""}
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
        {detail.date || ""}
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'left' }}>
        <Box display="flex" gap={1}>
          <Avatar
            sx={{
              bgcolor: projectColors[detail.code],
              width: 40,
              height: 40,
              fontSize: '13px',
            }}
          >
            {detail.code}
          </Avatar>
          <Box>
            <Typography fontWeight="bold">{detail.name}</Typography>
            <Typography variant="body2" color="text.secondary">
              {detail.desk}
            </Typography>
          </Box>
        </Box>
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
        {detail.manualHours}
      </TableCell> 
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
        {detail.started}
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
        {detail.stopped}
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
        {detail.duration} 
      </TableCell>
        <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'left' }}>
        <SessionsActivityBar activity={detail.activity} />
      </TableCell>
      <TableCell sx={{ padding: '10px 16px', border: 'none', backgroundColor: '#F0F7FF', color: '#626262', textAlign: 'center' }}>
        <Typography color="primary">
          {detail.notes || "-"}
        </Typography>
      </TableCell>
    </TableRow>
  );
};

export default SessionsMemberDetailsRow;